<template>
  <div class="timebar" v-bind:class="{ 'on_top': position === 'top', 'on_bottom': position === 'bottom' }" v-bind:style="{ 'width': `${Math.min(time / (totalTime * 10), 100)}%` }"></div>
</template>

<script>
export default {
  computed: {
    time() {
      if (this.timeLeft < 0) {
        return 0;
      }
      return this.timeLeft;
    },
  },
  name: 'TimeLeft',
  props: {
    timeLeft: Number,
    totalTime: Number,
    position: String,
  },
  data() {
    return {
      decimalCount: 0,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.on_top {
  margin-bottom: -5px;
}
.on_bottom {
  margin-top: -5px;
}
.timebar {
  position: relative;
  height: 5px;
  width: 100%;
  background: #28a745;
  z-index: 10;
  transition: all .4s;
}
</style>
